import { render, staticRenderFns } from "./AreaManagement.vue?vue&type=template&id=6472066e&scoped=true&"
import script from "./AreaManagement.vue?vue&type=script&lang=js&"
export * from "./AreaManagement.vue?vue&type=script&lang=js&"
import style0 from "./AreaManagement.vue?vue&type=style&index=0&id=6472066e&prod&lang=scss&scoped=true&"
import style1 from "./AreaManagement.vue?vue&type=style&index=1&id=6472066e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472066e",
  null
  
)

export default component.exports